import { useContext, useEffect, useMemo, useState } from "react";
import { FiltersDomain } from "src/components/filters/FiltersDomain";

import { DefaultPageHeader } from "src/components/headers/defaultPageHeader";
import { SimpleTable } from "src/components/tables/simpleTable";
import AddEditDomainForm from "src/containers/addEditDomain";
import { useAlert } from "src/contexts";
import { AppContext } from "src/contexts/AppContext";
import { useDomainsRowsColumns } from "src/data/domainData";
import { useDomainsList } from "src/hooks/useDomainsList";
import DeleteModal from "src/layouts/modal/deleteModal";
import { DomainType } from "src/types";
import { scope, security } from "src/utils";


function DomainsList() {
  const columns = useDomainsRowsColumns();
  const { organizationId } = useContext(AppContext);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [domainSelected, setDomainSelected] = useState<DomainType>();
  const { showAlert } = useAlert();
  const [filteredEnvironment, setFilteredEnvironment] = useState<string>("");
  const [filteredSecurity, setFilteredSecurity] = useState<string>("");


  const {
    domains,
    selectedDomains,
    isLoadingForm,
    isLoadingDeletion,
    setSearchTerm,
    setSelectedDomains,
    fetchDomains,
    createDomain,
    updateDomain,
    deleteDomain,
    searchTerm,
    // filteredData,
    // setFilteredData,
    isLoading,
  } = useDomainsList({ organizationId });

  useEffect(() => {
    fetchDomains();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    // if (value.trim() === "") {
    //   setFilteredData(domains);
    // } else {
    //   const lowercasedValue = value.toLowerCase();
    //   const results = domains?.filter(
    //     (item) =>
    //       item.host.toLowerCase().includes(lowercasedValue)
    //   );
    //   setFilteredData(results);
    // }
  };

  const handleOptionEnvironmentChange = (value: string) => {
    setFilteredEnvironment(value);
    console.log(value)
  };

  const handleOptionSecurityChange = (value: string) => {
    setFilteredSecurity(value);
  };

  const handleCreateDomain = async (domain: any) => {
    const { projectID, scopeIndex, isUnsecure, clusterID, ...rest } = domain;
    const scopeSpecificProps =
      scopeIndex === 0
        ? { environmentID: undefined, clusterID: clusterID }
        : { clusterID, environmentID: domain.environmentID }
  
    const securityProps = isUnsecure
      ? { certificateSecretNamespace: undefined, certificateSecretName: undefined }
      : {
        certificateSecretNamespace: domain.certificateSecretNamespace,
        certificateSecretName: domain.certificateSecretName,
      };
    const payload = {
      ...rest,
      ...scopeSpecificProps,
      ...securityProps,
      isUnsecure,
    };

    const success = await createDomain(payload);
    if (success) {
      setOpenModal(false);
              showAlert(
                "Domain creation",
                "Domain Created Successfully",
                "success"
              );

    }
  };
  

  const handleUpdateDomain = async (domain: any) => {
    const success = await updateDomain({
      ...domain,
      environmentName: domain.environmentID,
    });
    if (success) {
      handleCloseModal();
      showAlert("Domain edition", "Domain Edited Successfully", "success");
    }
  };

  const handleDeleteDomain = (domain: any) => {
    setDomainSelected(domain);
    setOpenDeleteModal(true)
  };
  const handleCloseDeleteModal = () => {
    setDomainSelected(undefined);
    setOpenDeleteModal(false);

  }

  const onDeleteDomain = async () => {
    if(domainSelected){
      const success = await deleteDomain(domainSelected.id);
      if (success) {
        setDomainSelected(undefined);
        setOpenDeleteModal(false);
        showAlert("Domain deletion", "Domain Deleted Successfully", "success");
  
      }

    }
  };
  const handleOpenEditDomain = (data: DomainType) => {
    setOpenModal(true)
    setIsEdit(true)
    setDomainSelected(data)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
    setDomainSelected(undefined)
    setIsEdit(false)
  }

  // const dataToShow = () => {
  //   return searchTerm === "" ? domains : filteredData
  // }

  const dataToShow = useMemo(() => {
    const dataToReturn =  domains?.filter((item) => {
      const matchesSecurity =
        filteredSecurity === "" || (
          filteredSecurity === "Enabled" && !item.isUnsecure
        ) || (
          filteredSecurity === "Disabled" && item.isUnsecure
        );
      const matchesEnvironment = filteredEnvironment === "" || (
        filteredEnvironment === "cluster" && item.environmentID === ""
      ) || (
        filteredEnvironment === "environment" && item.environmentID?.length > 0
      );
      const lowerCaseSearch = searchTerm.trim().toLowerCase();
      const matchesSearch =
        searchTerm === "" ||
        item.host?.toLowerCase()?.includes(lowerCaseSearch)
  
      return matchesSecurity && matchesSearch && matchesEnvironment;
    });
    return dataToReturn;
  }, [searchTerm, domains, filteredSecurity, filteredEnvironment]);


  return (
    <div className="flex flex-col gap-4 m-4">
      <DefaultPageHeader
        title="Domains"
        onAdd={() => setOpenModal(true)}
        buttonLabel="Add Domain"
      />
      <hr className="border-t border-gray-200" />

      <FiltersDomain
        onSearch={handleSearch}
        onOptionSecurityChange={handleOptionSecurityChange}
        onOptionScopeChange={handleOptionEnvironmentChange}
        optionsScope={scope}
        optionsSecurity={security}
      />
      <hr className="border-t border-gray-200" />
      <div className="flex flex-row items-center justify-between py-3">
        <div className="text-sm font-semibold text-gray-700">Domains List</div>
      </div>
      <SimpleTable
        columns={columns}
        rows={dataToShow as any[]}
        // onRowClick={(row) => navigate(`/domains/${row.id}`)}
        withElevation={false}
        onRowDelete={handleDeleteDomain}
        onRowEdit={(data) => handleOpenEditDomain(data)}
        onRowCheck={(domain) => {
          setSelectedDomains((prev) => {
            const index = prev.findIndex((g) => g.id === domain.id);
            if (index === -1) {
              return [...prev, domain];
            }
            return prev.filter((g) => g.id !== domain.id);
          });
        }}
        onAllRowsChecked={setSelectedDomains}
        selectedItems={selectedDomains}
        withCheckBox
        withAction
        isLoading={isLoading}
        searchTerm={searchTerm}
      />
      <AddEditDomainForm
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={isEdit ? handleUpdateDomain : handleCreateDomain}
        title={isEdit ? "Edit Domain" : "Add Domain"}
        description="Seamlessly connect your services and enhance our API management."
        submitTitleButton={isEdit ? "UPDATE DOMAIN" : "ADD DOMAIN"}
        isLoading={isLoadingForm}
        organizationId={organizationId}
        defaultValues={domainSelected}
        isUpdate={isEdit}
      />
      <DeleteModal
        open={openDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={onDeleteDomain}
        title="Delete Domain"
        isLoading={isLoadingDeletion}
        confirmationValue={domainSelected?.host}
      />
    </div>
  );
}
export default DomainsList;
